import { forwardRef } from 'react';
import { cn } from '../../../lib/utils';
import { Input } from '../../ui/input';
import { SearchIcon } from './icons';

interface ListSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  /** Accessible label — required for screen readers since there's no <label>. */
  ariaLabel: string;
  placeholder?: string;
  /** Test id for e2e selectors. */
  'data-testid'?: string;
  className?: string;
}

/**
 * Standard search field for list screens — left-inset magnifier
 * + native `type="search"` (browser cancel button handles clear). Defaults
 * to `sm:w-[280px]` so the field stays compact on desktop but expands on
 * mobile; override with `className`.
 */
export const ListSearchInput = forwardRef<HTMLInputElement, ListSearchInputProps>(
  ({ value, onChange, ariaLabel, placeholder, className, ...rest }, ref) => {
    return (
      <div className={cn('relative w-full sm:w-[280px]', className)}>
        <SearchIcon
          aria-hidden
          className="pointer-events-none absolute top-1/2 left-3 size-4 -translate-y-1/2 text-muted-foreground"
        />
        <Input
          ref={ref}
          type="search"
          aria-label={ariaLabel}
          placeholder={placeholder}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          className="pl-9"
          data-testid={rest['data-testid']}
        />
      </div>
    );
  }
);
ListSearchInput.displayName = 'ListSearchInput';
